export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref12127.d2084535.jpg";